import { DefaultOptionType } from "antd/lib/select";

export const filterPhoneCountries = (inputValue: string, option: DefaultOptionType | undefined) => {
  const trimmedInputValue = inputValue.trim().toLowerCase();
  const optionValue = String(option?.key ?? "").toLowerCase();

  return optionValue.startsWith(trimmedInputValue);
};
